import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initSentry } from "./sentry";

// Опциональная инициализация Sentry — не блокирует render
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
